<template>
  <!-- 错词列表模块  -->
  <div class="wrong-data">
    <div class="tea-search">
      <el-form ref="form" :inline="true" class="demo-form-inline" size="small">
        <!-- 选择集训场次 -->
        <!-- <el-form-item>
          <el-select>
            <el-options></el-options>
          </el-select>
        </el-form-item> -->
        <!--  -->
        <el-form-item>
          <el-date-picker v-model="time_list" type="daterange" :clearable='false' range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="timeChange()">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <div class="search-text" style="width:300px">
            <el-input placeholder="请输入学生姓名或关键字查询" v-model="search_data.dcmc" class="input-with-select">
            </el-input>
          </div>
        </el-form-item>
        <el-form-item class="fr">
          <el-button icon="el-icon-search" type="primary" class="fl tea-btn" @click="handelSearch()">查 询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="wrong-table">
      <el-table stripe border :data="tableData" height="calc(100% - 40px)">
        <el-table-column type="index" label="序号" align="center" width="50" :index="indexMethod" />
        <el-table-column prop="dcmc" label="单词" align="center" />
        <el-table-column prop="dymc" label="错词来源" align="center" />
        <el-table-column prop="ccrs" label="出错人数" align="center" />
        <el-table-column prop="cccs" label="出错次数" align="center" />
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button icon="el-icon-view" circle type="primary" size="mini" @click="lookWord(scope.row)"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="tea-pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pages.pageSize" layout="total, sizes, prev, pager, next" :total="pages.total">
        </el-pagination>
      </div>
    </div>
    <!-- 查看错词的pop -->
    <el-dialog :title="wrong_word_obj.title" :visible.sync="wrong_word_obj.dialogVisible" width='800px' :modal-append-to-body="true" class="tea-diolag">
      <div class="wrong-main">
        <el-table stripe border :data="wrong_word_obj.list" height="calc(100% - 40px)">
          <el-table-column prop="cctx" label="题型" align="center" />
          <el-table-column prop="errorPersonNum" label="出错人数" align="center" />
          <el-table-column prop="errorTimes" label="出错次数" align="center" />
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  classTempWrongWordListApi,//错词列表
} from '@/api/teacher'
export default {
  data() {
    return {
      model_type: '1',//1班级成绩 2测试成绩 3小组成绩
      yhid: this.$store.state.userInfo.yhid,
      zhid: this.$store.state.userInfo.zhid,
      bjlx: this.$route.query.lx,
      bjid: this.$route.query.bjid,
      bjmc: this.$route.query.bjmc,
      //   日期和关键字
      search_data: {
        yhid: this.$store.state.userInfo.yhid,
        zhid: this.$store.state.userInfo.zhid,
        bjid: this.$route.query.bjid,
        bjmc: this.$route.query.bjmc,
        dcmc: null,
      },
      time_list: [
        this.$route.query.yxqq, this.$route.query.yxqz,
      ],
      tableData: [],
      //   分页数据
      pages: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      // -------------------------------错词详情
      wrong_word_obj: {
        title: 'print',
        dialogVisible: false,
        search_data: {},
        list: [],
      },
    }
  },
  created() {

  },
  mounted() {
    this.geWrongWordList()
  },
  methods: {
    // -----------------------------查询列表
    geWrongWordList() {
      const data = JSON.parse(JSON.stringify(this.search_data));
      data.currentPage = this.pages.currentPage;
      data.pageSize = this.pages.pageSize;
      data.startTime = this.time_list[0];
      data.endTime = this.time_list[1];
      classTempWrongWordListApi(data).then(res => {
        if (res.result) {
          console.log(res.result)
          this.tableData = res.result.list;
          this.pages.total = res.result.total
        }
      })
    },
    // 时间区间改变
    timeChange() {
      console.log(this.time_list)
    },
    indexMethod(index) {
      return (this.pages.currentPage - 1) * this.pages.pageSize + index + 1;
    },
    handelSearch() {
      this.pages.currentPage = 1;
      this.geWrongWordList()
    },
    //  ---------------------------分页查询
    handleSizeChange(val) {
      this.pages.pageSize = val;
      this.handelSearch()
    },
    handleCurrentChange(val) {
      this.pages.currentPage = val;
      this.geWrongWordList()
    },
    // --------------------------------插卡错词
    lookWord(result) {
      console.log(result)
      this.wrong_word_obj.list = []
      this.wrong_word_obj.dialogVisible = true;
      this.wrong_word_obj.title = result.dcmc;
      this.wrong_word_obj.list = result.questionTypeOfWordList
    },
  }
}
</script>
<style lang="scss" scoped>
.wrong-data {
  height: 100%;
  position: relative;
}
.tea-search {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
}
.wrong-table {
  height: calc(100% - 60px);
  .tea-pagination {
    margin-top: 10px;
  }
}
::v-deep .el-dialog__body {
  height: 400px;
}
</style>